module.exports = __webpack_public_path__ + "static/media/1.22f6124a.svg";